import styled from 'styled-components';
import { darken } from 'polished';

import { black, grey200, grey500 } from 'styles/colors';
import { mMedium, xxsRegularUppercase } from 'styles/typography';

export const Wrapper = styled.div`
	width: 100%;
`;

export const Input = styled.input`
	appearance: none;
	width: 100%;
	border-radius: 0;
	border: 1px solid ${grey200};
	padding: 7.5px 18px 6.5px 8.5px;
	color: ${black};
	${mMedium};

	&:focus,
	&:active {
		outline: none;
		border-color: ${darken(0.2, grey200)};
	}
	&:disabled {
		background-color: ${props => (props.disabled ? '#e7e7e7' : 'inherit')};
	}
`;

export const Label = styled.label`
	text-overflow: ellipsis;
	margin-bottom: 8px;
	color: ${grey500};
	max-width: 100%;
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	${xxsRegularUppercase};
`;
